import { run } from 'shared'
import { ReactNode } from 'react'

type INodeActionName = 'download' | 'move' | 'delete' | 'rename' | 'toggle-favorite' | 'file-analysis'

const SORTED_NODE_ACTIONS: INodeActionName[] = run(() => {
    const sortedMap: Record<INodeActionName, true> = {
        download: true,
        move: true,
        rename: true,
        'file-analysis': true,
        'toggle-favorite': true,
        delete: true,
    }

    return Object.keys(sortedMap) as INodeActionName[]
})

export const defineNodeActions = (actionsMap: Record<INodeActionName, undefined | false | null | ReactNode>) => {
    return Object.entries(actionsMap)
        .reduce<{ name: INodeActionName; node: ReactNode }[]>((acc, [key, value]) => {
            if (value) acc.push({ name: key as INodeActionName, node: value })

            return acc
        }, [])
        .sort((a, b) => SORTED_NODE_ACTIONS.indexOf(a.name) - SORTED_NODE_ACTIONS.indexOf(b.name))
}
